import * as React from 'react'

import './TextInput.sass'

export interface IProps {
  error?: any,
  type?: string,
  placeholder?: string,
  onChange: any,
  onBlur?: any,
  value: any,
  name?: string,
  label: string,
  touched?: any,
  autoComplete?: string
}

export default function TextInput(props: IProps): React.ReactElement {
  const {error, touched, label} = props

  const isError = error && touched ? 'error' : ''

  const renderErrorOrOptional = (): JSX.Element | null => {
    return error && touched ? <div className='error-message'>{error}</div> : null
  }

  return (
    <div className={`text-input-wrapper ${isError}`}>
      <input className='input' {...props} />
      <div className='text-input-header'>
        <label>{label}</label>
        {renderErrorOrOptional()}
      </div>
    </div>
  )
}
